/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import moment from "moment";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import CycleModal from "../Cycles/CycleModal.vue";

export default {
  name: "Cycles",
  components: {
    VPagination,
    CycleModal
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      currentPage: 1,
      totalPage: 1,
      pageindex: 1,
      pagesize: 10,
      SortProperty: "createdAt",
      SortOrder: 1,
      SortOrderInt: 0,
      isAscending: true,
      totalCount: 0,

      showCycleTableLoading: false,
      cycleList: [],
      currentPageCycle: 1,
      cycleTotalCount: 0,
      cycleTotalPage: 1,
      cyclepagesize: 10,
      SortCycleProperty: "cycleId",
      isCycleAscending: true,
      showCreateCycleModal: false,
      editingCycleId: null,

      idToken: "",
      roleprivileges: "",
      studyversion:"",
      selectedcolumnobj: {
        CycleId: true,
        CycleName: true,
        ArmCode: true
      },
    }
  },
  async mounted() {
    await this.getstudyversion();
    window.addEventListener("studyIdChanged", async (event) => {
      console.log("StudyIDChanged into" + event.detail.storage);
      await this.getstudyversion();
      this.idToken = store.getters.getIdToken;
      this.listCycles();
    });
    await this.listCycles();
  },

  methods: {
    SortSelected(property) {
      console.log("SortPropChanged:", property);

      if (this.SortCycleProperty === property) {
        this.SortOrderInt = this.SortOrderInt === 0 ? 1 : 0;
      } else {
        this.SortCycleProperty = property;
        this.SortOrderInt = 0;
      }

      this.activeSortColumn = property;
      this.currentPage = 1;

      console.log(`Sorting by ${this.SortCycleProperty}, order: ${this.SortOrderInt}`);

      this.listCycles();
    },
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
    },
async getstudyversion() {
  try {
    const currentstudy = store.getters.getStudyIs;
    this.idToken = store.getters.getIdToken;

    const response = await axios.get(`${this.baseurl}/management/study/studyversionlist?studyId=${currentstudy}&isActive=true`, {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json"
      }
    });


    this.studyversion = response.data[0] || "";

  } catch (error) {
    console.error("Error fetching studyversion:", error);
  } 
     },

  async listCycles() {
  try {
    this.showCycleTableLoading = true;
    const currentstudy = store.getters.getStudyIs;
    this.idToken = store.getters.getIdToken;

    const response = await axios.get(
      // `https://localhost:54930/cycle/listcycles?studyId=${currentstudy}&studyVersion=${this.studyversion}&pageindex=${this.currentPageCycle}&pagesize=${this.cyclepagesize}&SortProperty=${this.SortCycleProperty}&SortOrder=${this.SortOrderInt}`, {
      `${this.baseurl}/management/cycle/listcycles?studyId=${currentstudy}&studyVersion=${this.studyversion}&pageindex=${this.currentPageCycle}&pagesize=${this.cyclepagesize}&SortProperty=${this.SortCycleProperty}&SortOrder=${this.SortOrderInt}`, {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json"
      }
    });


    this.cycleList = response.data.entities || [];
    this.cycleTotalCount = response.data.totalCount;
    this.cycleTotalPage = Math.ceil(this.cycleTotalCount / this.cyclepagesize);
  } catch (error) {
    console.error("Error fetching cycles:", error);
    this.cycleList = [];
  } finally {
    this.showCycleTableLoading = false;
  }
     },

    EditCycle(Id) {
      this.editingCycleId = Id;
      console.log("Editing Cycle with ID:", Id);
      this.showCreateCycleModal = true;
    },

    async DeleteCycle(Id) {
     if (confirm("Are you sure you want to delete this Cycle?")) {
    try {
      const response = await axios.delete(
        `${this.baseurl}/management/cycle/deletecycle?id=${Id}`, {
        headers: {
          Authorization: "Bearer " + this.idToken,
          "Content-Type": "application/json"
        }
      });
      alert("Cycle deleted successfully.");
      this.listCycles();
    } catch (error) {
      console.error("Error deleting Cycle:", error);
      alert("Failed to delete Cycle.");
    }
  }
    },

    loadPageCycle(page) {
      this.currentPageCycle = page;
      this.listCycles();
    },

    SortCycleSelected(sortProp) {
      if (this.SortCycleProperty === sortProp) {
        this.isCycleAscending = !this.isCycleAscending;
      } else {
        this.SortCycleProperty = sortProp;
        this.isCycleAscending = true;
      }
      this.SortOrderInt = this.isCycleAscending ? 0 : 1;
      this.pageindex = 1;
      this.currentPage = 1;
      this.listCycles();
    },

    closeCycleModal() {
      this.showCreateCycleModal = false;
      this.editingCycleId = null;
    },

     CreateCycle() {
      this.editingCycleId = null;
      this.showCreateCycleModal = true;
    },

    async refreshCycleList() {
      await this.listCycles(); 
    }
  }
};